<template>
    <footer>
        <div
            v-if="data?.footerItems?.length !== undefined"
            class="container grid py-12 text-sm text-white lg:grid-cols-12 lg:gap-y-8">
            <div class="flex flex-col gap-6 lg:col-span-4">
                <div class="uptimise">
                    <SvgComponent class="mb-10 h-8 w-[129px]" icon="logo-uptimise" />
                    <p class="lg:max-w-68">{{ data?.footerText }}</p>
                </div>
                <div class="interreg flex flex-col gap-2 lg:max-w-68">
                    <p v-if="data.interregText">{{ data.interregText }}</p>
                    <img
                        v-if="data.interregImage"
                        class="h-auto max-w-[200px]"
                        :src="data.interregImage.url"
                        :alt="data.interregImage.alt ?? ''"
                        :title="data.interregImage.title ?? ''" />
                </div>
            </div>
            <div class="lg:grid-cols-auto-fit my-2 grid gap-x-0 gap-y-5 lg:col-span-8 lg:my-0">
                <div v-for="list in data?.footerItems" :key="list.title ?? 'footer-list'">
                    <button
                        class="text-blue-heavy-50 flex w-full cursor-pointer items-center justify-between font-bold lg:cursor-default"
                        :aria-expanded="
                            isOpen === removeWhiteSpaceAndSpecialCharacters(list?.title)
                        "
                        :aria-controls="removeWhiteSpaceAndSpecialCharacters(list?.title)"
                        :data-test="removeWhiteSpaceAndSpecialCharacters(list?.title)"
                        @click="toggleAccordion(removeWhiteSpaceAndSpecialCharacters(list?.title))">
                        {{ list.title }}
                        <SvgComponent
                            icon="chevron-down"
                            class="w-4 transition-transform duration-300 lg:hidden"
                            :class="{
                                'rotate-180':
                                    isOpen === removeWhiteSpaceAndSpecialCharacters(list?.title),
                            }" />
                    </button>
                    <div
                        :id="removeWhiteSpaceAndSpecialCharacters(list.title)"
                        class="grid grid-rows-[0fr] gap-y-0 overflow-hidden transition-[grid-template-rows] duration-300 lg:grid-rows-[1fr]"
                        :class="{
                            'grid-rows-[1fr]':
                                isOpen === removeWhiteSpaceAndSpecialCharacters(list?.title),
                        }"
                        role="region">
                        <ul class="overflow-hidden">
                            <li
                                v-for="item in list.items"
                                :key="item.title"
                                class="mt-2 overflow-hidden">
                                <NuxtLink
                                    :target="item.openInNewTab ? '_blank' : '_self'"
                                    :to="localeRoute(item.url)"
                                    >{{ item.title }}</NuxtLink
                                >
                            </li>
                        </ul>
                    </div>
                </div>
            </div>
            <div
                class="text-blue-heavy-50 flex flex-col flex-wrap justify-between lg:col-span-12 lg:mt-0 lg:flex-row">
                <p>{{ data?.bottomFooterText }}</p>
                <div class="grid-cols-auto mt-4 grid lg:mt-0">
                    <ul class="flex flex-col flex-wrap gap-2 lg:flex-row lg:gap-6">
                        <li v-for="item in data?.bottomFooterItems" :key="item.title">
                            <NuxtLink
                                :target="item.openInNewTab ? '_blank' : '_self'"
                                :to="localeRoute(item.url ?? '/')"
                                >{{ item.title }}</NuxtLink
                            >
                        </li>
                    </ul>
                </div>
            </div>
        </div>
    </footer>
</template>
<script lang="ts" setup>
import type { FooterNavigationModel } from '@su4r-frontend/api';

const { data } = defineProps<{ data?: FooterNavigationModel }>();

const localeRoute = useLocaleRoute();

const isOpen = ref<string>('');

const toggleAccordion = (id: string): void => {
    isOpen.value = isOpen.value === id ? '' : id;
};
</script>
